import { FC, useState } from 'react';

import { OnUserActionRequiredReturnType } from '@/shared/lib/sj-orm/migrator';
import { CollectionName } from '@/shared/lib/sj-orm/types';
import { Button } from '@/shared/uikit/Button';
import { Title } from '@/shared/uikit/Title';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { isDtoId } from '@/shared/utils/is';

import { useModalsStore } from '../../modals.store';
import { UpdateCollectionsModalProps } from '../../types';

import { Table } from './components/table';
import { UpdateItem } from './components/UpdateItem';
import { Actions, Body, Container, Description, Header, StyledDrawer, TabsStyled } from './styled';
import { ItemBaseDto, UpdateCollectionsModalCollectionItem } from './types';
// TODO modal container RightSide
export const UpdateCollectionsModal: FC<UpdateCollectionsModalProps> = ({
  collections,
  onSubmit,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'updateCollections' });
  const { t: tsc } = useTranslation('shared/collections');
  const modals = useModalsStore();

  const [tab, setTab] = useState<CollectionName>(collections[0].name);
  const [dtoItem, setDtoItem] = useState<UpdateCollectionsModalCollectionItem | null>(null);

  const [filledItems, setFilledItems] = useState<Record<string, ItemBaseDto>>({});

  const tabs = collections.map((item) => ({ key: item.name, label: tsc(`names.${item.name}`) }));
  const tableData = collections.find((item) => item.name === tab);

  const handleConfirm = () => {
    modals.closeModal();

    const resultCollections: OnUserActionRequiredReturnType['collections'] = new Map();

    collections.forEach(({ name }) => {
      resultCollections.set(name, new Map());
    });

    Object.values(filledItems).forEach((item) => {
      const collectionName = isDtoId(item.id);

      if (!collectionName) {
        return;
      }

      const resultCollection = resultCollections.get(collectionName);

      if (!resultCollection) {
        return;
      }

      resultCollection.set(item.id, item);
    });

    onSubmit(resultCollections);
  };

  const handleChange = (item: UpdateCollectionsModalCollectionItem) => {
    setFilledItems((prev) => {
      return { ...prev, [item.data.id]: item.data };
    });
  };

  const totalItemsCount = collections.reduce((acc, collection) => {
    const collectionItems = collection.items.length;
    return acc + collectionItems;
  }, 0);

  const filledIds = Object.keys(filledItems);

  const submitDisabled = totalItemsCount > filledIds.length;

  return (
    <>
      <StyledDrawer width={800} open={true} closable={false} footer={null}>
        <Container>
          <Header>
            <Title size={22} bold>
              {t('title')}
            </Title>
            <Description style={{ marginTop: 4 }}>{t.rich('description')}</Description>
            <TabsStyled
              defaultActiveKey={tab}
              items={tabs}
              onChange={(value) => setTab(value as CollectionName)}
            />
          </Header>
          <Body className="uikitScrollbar">
            {tableData && (
              <Table
                collectionName={tableData.name}
                items={tableData.items}
                onSelect={(data) => setDtoItem(data)}
                filledItems={filledItems}
              />
            )}
          </Body>
          <Actions>
            <Button onClick={handleConfirm} style={{ width: 200 }} disabled={submitDisabled}>
              {t('btnConfirm')}
            </Button>
          </Actions>
        </Container>
      </StyledDrawer>
      {dtoItem && (
        <UpdateItem
          item={dtoItem}
          filledData={filledItems[dtoItem.data.id]}
          onChange={(data) => handleChange(data)}
          onCancel={() => setDtoItem(null)}
        />
      )}
    </>
  );
};
